import React, {FC} from 'react';
import styled from "styled-components";
import AcceptIcon from "../../../media/icons/accept.svg?react";

const StyledAcceptIcon = styled(AcceptIcon)<{ $active?: boolean }>`
  width: 22px;
  height: 22px;
  
  path {
    fill: ${({$active}) => ($active ? "#ffffff" : "#808080")};
    transition: fill 0.2s ease;
  }
`;

const StatusButton = styled.button<{ $active: boolean; disabled?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: ${({$active}) => $active ? "none" : "1px solid #808080"};
  background-color: ${({$active}) => $active ? "#448df7" : "transparent"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({disabled}) => disabled ? "not-allowed" : "pointer"};
  transition: background-color 0.2s ease, border-color 0.2s ease;
  color: ${({$active}) => ($active ? "#ffffff" : "#808080")};
  flex-shrink: 0;
  padding: 0;
  opacity: ${({disabled, $active}) => (disabled && !$active) ? 0.6 : 1};

  &:hover:not(:disabled) {
    background-color: #3a7fe0;
    border-color: transparent;
    color: #fff;
    
    ${StyledAcceptIcon} {
      path {
        fill: #ffffff;
      }
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

interface IAcceptButton {
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export const AcceptButton: FC<IAcceptButton> = ({active = false, onClick, disabled = false}) => {
  return (
    <StatusButton
      type="button"
      $active={active}
      onClick={onClick}
      disabled={disabled}
    >
      <StyledAcceptIcon $active={active} />
    </StatusButton>
  );
};

